import _ from 'lodash';
import { baseUtils } from './baseUtils';
const customDownloadUrlThrottleDownload = _.throttle(async (customDownloadUrl, url, photoId) => {
  try {
    const downloadUrl = await customDownloadUrl(url, photoId);
    if (baseUtils.isiOS()) {
      window.location.href = downloadUrl;
    } else {
      window.open(downloadUrl, '_blank');
    }
  } catch (error) {
    console.error('Failed to get custom download url', error);
  }
}, 2000);
export { customDownloadUrlThrottleDownload };
//# sourceMappingURL=downloadLinkUtils.js.map